module.exports = __webpack_public_path__ + "static/media/step-8-open-ticket.6217a78f.png";